/* eslint-disable no-unused-vars */
import "../assets/css/profile.css";
import {  faCalendarCheck } from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";

import {
  faCamera,
  faUser,
  faEnvelope,
  faPhone,
  faIdCard,
  faVenusMars,
  faMapMarkerAlt,
  faGlobe,
  faBuilding,
  faFingerprint,
  faPerson,
  faHome,
  faLock,
  faKey,
  faLocationArrow,
  faMapPin,
  faVideo,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

const ProfilePage = () => {
  const dispatch = useDispatch();
  const { profile, loading, error } = useSelector((state) => state.userProfile);

  const [updateType, setUpdateType] = useState("password");
  const [formData, setFormData] = useState({
    old: "",
    new: "",
    confirmNew: "",
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [showCamera, setShowCamera] = useState(false);

  const [cibilUser, setCibilUser] = useState(null);
const [wallet, setWallet] = useState(0);
const [price, setPrice] = useState(0);
const [uid, setUid] = useState("");
const [loadingUser, setLoadingUser] = useState(false);


  const videoRef = useRef(null);
  const canvasRef = useRef(null);




  useEffect(() => {
  getCibilUser();
}, []);

const getCibilUser = async () => {
  try {
    setLoadingUser(true);

    const email = profile?.email || "sonu@gmail.com"; // Auto fetch when profile loads

    const res = await axios.get(
      `https://narrowitsolution.in/api/cibil-profile-user-by-email?email=${email}`
    );

    if (res.data.success) {
      const data = res.data.data;

      setCibilUser(data);
      setWallet(data.wallet);
      setPrice(data.price);
      setUid(data.uid);
    }
  } catch (err) {
    console.log("CIBIL USER ERROR", err);
  } finally {
    setLoadingUser(false);
  }
};


  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const handleTypeChange = (e) => {
    setUpdateType(e.target.value);
    setFormData({ old: "", new: "", confirmNew: "" });
  };

  const handleInputChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSave = () => {
    console.log(`Updating ${updateType}`, formData);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImagePreview(imageUrl);
      console.log("Image Selected:", file);
    }
  };

  const openCamera = async () => {
    setShowCamera(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoRef.current.srcObject = stream;
      videoRef.current.play();
    } catch (err) {
      toast.error("Camera access denied or not available.");
    }
  };

  const closeCamera = () => {
    setShowCamera(false);
    if (videoRef.current?.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach((track) => track.stop());
    }
  };

  const captureImage = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);
    const dataUrl = canvas.toDataURL("image/jpeg");
    setImagePreview(dataUrl);
    closeCamera();
  };
  
  // For Date of joning//

  const formattedDOJ = profile?.dateOfJoining
  ? new Date(profile.dateOfJoining).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  : "N/A";
 // you may also add date of birth here //
  const personalInfo = [
    { label: "PAN Number", value: profile?.panNumber, icon: faIdCard },
    { label: "Aadhaar Number", value: profile?.aadhaarNumber, icon: faFingerprint },
    { label: "Gender", value: profile?.gender, icon: faVenusMars },
    { label: "Date of Joining", value: formattedDOJ, icon: faCalendarCheck },
    // { label: "Guardian Name", value: profile?.guardianName, icon: faPerson },
    { label: "Marital Status", value: profile?.maritalStatus, icon: faUser },
    { label: "Full Address", value: profile?.address, icon: faMapMarkerAlt },
    { label: "PIN Code", value: profile?.pincode, icon: faMapPin },
    { label: "Post Office", value: profile?.postOffice, icon: faLocationArrow },
    { label: "Sub District", value: profile?.subDistrict, icon: faHome },
    { label: "District", value: profile?.district, icon: faMapMarkerAlt },
    { label: "State", value: profile?.state, icon: faMapMarkerAlt },
    { label: "Country", value: profile?.country, icon: faGlobe },
    { label: "Branch Name", value: profile?.branchName, icon: faBuilding },
    
    
  ];

  return (
    <div className="UserProfile-container">
      <div className="UserProfile-wrapper">
        {loading && <p>Loading profile...</p>}
        {error && <p className="UserProfile-error">Error: {error}</p>}

        {/* Header */}
      <section className="UserProfile-card UserProfile-header">

  {/* LEFT SIDE → Profile Image */}
  <div className="UserProfile-header-left">
    <div className="UserProfile-image-box">
      <img
        className="UserProfile-image"
        src={ imagePreview || "https://randomuser.me/api/portraits/men/75.jpg" }
        alt="Profile"
      />
      <div className="UserProfile-camera-icon">
        <FontAwesomeIcon
          icon={faFile}
          onClick={() => document.getElementById("upload-photo").click()}
        />
        <input
          type="file"
          id="upload-photo"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleImageChange}
        />
      </div>

      {/* Camera icon */}
      <div className="UserProfile-camera-icon" style={{ right: "40px" }}>
        <FontAwesomeIcon icon={faCamera} onClick={openCamera} />
      </div>
    </div>
  </div>

  {/* MIDDLE → NAME + DETAILS */}
  <div className="UserProfile-header-middle">
    <h1>
      {profile?.fullName}
      <span className="UserProfile-id"> ({profile?.superAdminId})</span>
    </h1>

    <p className="UserProfile-role">{profile?.roleName}</p>

    <div className="UserProfile-contact">
      <p><FontAwesomeIcon icon={faEnvelope} /> {profile?.email}</p>
      <p><FontAwesomeIcon icon={faPhone} /> {profile?.mobileNumber}</p>
    </div>
  </div>

  {/* RIGHT SIDE → WALLET BOX */}
  <div className="UserProfile-wallet-box">
    <h3 className="wallet-title">CIBIL Wallet</h3>

    <div className="wallet-balance">
     <h2>₹ {wallet || 0}</h2>

      <p>Available Balance</p>
    </div>

   
  </div>

</section>


        {/* Personal Info */}
        <section className="UserProfile-card">
          <h2>
            <FontAwesomeIcon icon={faUser} className="UserProfile-icon" /> Personal Information
          </h2>
          <div className="UserProfile-info-grid">
            {personalInfo.map((item, index) => (
              <div key={index} className="UserProfile-info-item">
                <FontAwesomeIcon icon={item.icon} className="UserProfile-info-icon" />
                <div>
                  <span className="UserProfile-label">{item.label}</span>
                  <span className="UserProfile-value">{item.value || "—"}</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Update Password or PIN */}
     



      </div>

      {/* Camera Modal */}
      {showCamera && (
        <div className="camera-modal">
          <div className="camera-modal-content">
            <video ref={videoRef} autoPlay playsInline />
            <canvas ref={canvasRef} style={{ display: "none" }} />
            <div className="camera-controls">
              <button onClick={captureImage}>Capture</button>
              <button onClick={closeCamera}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
